export default "__VITE_ASSET__HDZtl6j8__"